import { Injectable } from '@angular/core';

import { CatalogObjectTypes } from '@mirage-projects/cw-models';

import { ObjectBrowserSelectionService } from '../object-browser/selection.service';

@Injectable({
    providedIn: 'root',
})
export class GridService {
    constructor(private selectionService: ObjectBrowserSelectionService) {}

    /**
     * Method to update the state of all elements checked to select or unselected
     * @param elementChecked Element to update selection state
     * @param selected Marks if it has to select element or not
     * @param catalogType Type of CatalogObject
     */
    updateCheckedElementsState(elementChecked: any, selected: boolean, catalogType: CatalogObjectTypes = 'projects'): void {
        if (selected) {
            this.selectionService.select(elementChecked, catalogType);
        } else {
            this.selectionService.unselect(elementChecked, catalogType);
        }
    }
}
